import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import app from './app';
import config from './config';
import home from '../../home/reducers';
import auth from '../../auth/reducers';
import profiles from '../../profiles/reducers';
import tickets from '../../tickets/reducers';
import clients from '../../clients/reducers';
import contacts from '../../contacts/reducers';
import settings from '../../settings/reducers';
import users from '../../users/reducers';
import agencies from "../../agencies/reducers";
import companies from "../../companies/reducers";
import dealers from "../../dealers/reducers";
import dashboard from "../../dashboard/reducers";

const persistConfig = {
    key: 'root',
    storage,
    blacklist: [
        'app',
        'clients',
        'contacts',
        'tickets',
        'users',
        'agencies',
        'companies',
        'dealers',
        'dashboard'
    ],
    whitelist: [
        'config',
        'home',
        'auth',
        'profiles',
        'settings'
    ]
};

const rootReducer = combineReducers({
    app,
    config,
    home,
    auth,
    profiles,
    tickets,
    clients,
    contacts,
    settings,
    users,
    agencies,
    companies,
    dealers,
    dashboard
});

export default persistReducer(persistConfig, rootReducer);
